export const UrlsForForm = {
  basicInfoSection: "/basic-info",
  lowRiskSection: "/low-risk",
  highRiskSection: "/high-risk",
};

export const highRiskQuestions = [
  {
    section: "Demonstration of Knowledge",
    rows: [
      {
        title:
          "PIC certified by accredited program, or compliance with Code, or correct answers",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 5,
      },
      {
        title:
          "Food Worker Cards current for all food workers new food workers trained",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 5,
      },
    ],
  },
  {
    section: "Employee Health",
    rows: [
      {
        title:
          "Proper ill worker and conditional employee practices; no ill practices workers present proper reporting of illness",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 25,
      },
    ],
  },
  {
    section: "Preventing Contamination by Hands",
    rows: [
      {
        title: "Hands washed as required",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 25,
      },
      {
        title:
          "Proper barriers used to prevent bare hand contact with ready to eat foods",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 25,
      },
      {
        title: "Adequate handwashing facilities",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 10,
      },
    ],
  },
  {
    section: "Approved Source, Wholesome, Not Adulterated",
    rows: [
      {
        title: "Food obtained from approved source",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 15,
      },
      {
        title: "Water supply, ice from approved source",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 15,
      },
      {
        title: "Proper washing of fruits and vegetables",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 10,
      },
      {
        title:
          "Food in good condition, safe and unadulterated approved additives",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 10,
      },
      {
        title:
          "Proper disposition of returned, previously served unsafe, or contaminated food",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 10,
      },
      {
        title:
          "OProper shellstock identification; wild mushroom ID parasite destruction procedures for fish",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 5,
      },
    ],
  },
  {
    section: "Employee Health",
    rows: [
      {
        title:
          "Food contact surfaces and utensils used for raw meat thoroughly cleaned and sanitized. No cross contamination",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 25,
      },
      {
        title:
          "Raw meats below or away from ready to eat food; species separated",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 25,
      },
      {
        title: "Proper handling of pooled eggs",
        correctedDuringInspection: false,
        repeatViolation: false,
        pts: 25,
      },
    ],
  },
];



export const lowRiskQuestions = [
  {
    section: "Food Temperature Control",
    rows: [
      {
        title: "Food received at proper temperature",
        pts: 5,
      },
      {
        title: "Adequate equipment for temperature control",
        pts: 5,
      },
      {
        title: "Proper thawing methods used",
        pts: 3,
      },
    ],
  },
  {
    section: "Food Identification",
    rows: [
      {
        title: "Proper labeling, signage",
        pts: 5,
      },
    ],
  },
  {
    section: "Protection from Contamination",
    rows: [
      {
        title: "Insects, rodents, animals not present; entrance controlled",
        pts: 5,
      },
      {
        title:
          "Potential food contamination prevented during delivery preparation, storage, display",
        pts: 5,
      },
      {
        title: "Wiping cloths properly used, stored; proper sanitizer",
        pts: 5,
      },
      {
        title: "Employee cleanliness and hygiene",
        pts: 3,
      },
      {
        title: "Proper eating, tasting, drinking, or tobacco use",
        pts: 3,
      },
    ],
  },
  {
    section: "Proper Use of Utensils",
    rows: [
      {
        title: "In-use utensils properly stored",
        pts: 3,
      },
      {
        title: "Utensils, equipment, linens properly stored, used, handled",
        pts: 3,
      },
      {
        title: "Single-use and single-service articles properly stored, used",
        pts: 3,
      },
    ],
  },
];


export var temp = [
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: true,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  }
]

export const tempTwo = [
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: true,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
  {
    correctedDuringInspection: false,
    repeatViolation: false,
  },
]